import { Component, Input } from '@angular/core';
import { FilterModelDto } from '../../../../models/filter.model';

@Component({
  selector: 'app-user-page-filter',
  templateUrl: './user-page-filter.component.html',
  styleUrls: ['./user-page-filter.component.scss'],
})
export class UserPageFilterComponent {
  @Input() filterRoles: FilterModelDto[] | undefined;
  @Input() filterStatuses: FilterModelDto[] | undefined;
  @Input() filter2fa: FilterModelDto[] | undefined;

  filterStart: FilterModelDto = {
    fieldName: 'date_from',
    value: '',
    description: '',
  };

  filterEnd: FilterModelDto = {
    fieldName: 'date_to',
    value: '',
    description: '',
  };
}
